<template>
  <div>
    <p>My Peer Id : {{ myPeerId }}</p>
    <hr />
    <p>
      Remote Peer Id
      <input v-model="remotePeerId" />
    </p>
    <hr />
    <div class="col-xs-12 col-sm-6">
      <h3>Send Message</h3>
      <div @click="sendMessage()">send</div>
    </div>
    <div class="col-xs-12 col-sm-6">
      <h3>Received Messages</h3>
      <ul class="list-group">
        <li
          class="list-group-item"
          v-for="(message, index) in messages"
          :key="index"
        >
          Message: {{ message }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import Card from "../components/Cards/Event.vue";
import Peer from "peerjs";

export default {
  data: () => ({
    connection: null,
    connecting: true,
    message: "",
    messages: [],
    myPeer: null,
    myPeerId: "",
    remotePeerId: "",
  }),
  created() {
    this.myPeer = new Peer();
    this.myPeer.on("open", (id) => {
      console.log("Connected at PeerJS server with success");
      console.log("My peer ID is: " + id);
      this.myPeerId = id;
      this.connecting = false;
    });
    var self = this;
    this.myPeer.on("connection", function(conn) {
      conn.on("data", function(data) {
        // Will print 'hi!'
        self.messages.push(data);
      });
    });
  },
  computed: {},
  methods: {
    sendMessage() {
      const newMessage = {
        id: this.myPeerId,
        message: "hi",
      };
      var conn = this.myPeer.connect(this.remotePeerId);
      conn.send(newMessage);
      // on open will be launch when you successfully connect to PeerServer
      conn.on("open", function() {
        console.log("connected");
        // here you have conn.id;
        conn.send("hi!");
      });
    },
  },
  filters: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  text-decoration: underline;
}
.highlight {
  background: white;
  @apply p-8 mb-6 border mx-auto;
  width: 80%;
  max-width: 600px;
  h1.title {
    @apply text-3xl mt-0 mb-0;
  }
}
h2 {
  text-decoration: underline;
  @apply px-3;
}
.hooper:focus {
  outline: none;
}
.text {
  text-align: left;
  width: 65%;
  margin: 0 auto;
}
.select {
  @apply py-4 px-3  border-b;
  transition: all 0.1s ease;
  &:hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.01);
  }
  &.active {
    background: rgba(0, 0, 0, 0.02);
    @apply font-bold;
  }
}
.welcome {
  width: 80%;
  @apply mx-auto px-2 border-b;
}
.hooper {
  width: 100%;
}
.cards_row {
  @apply p-20;
  width: 100%;
  margin: 0 auto;
  background: #fff;
}
.distrikt {
  .card_large {
    .card_header.has_image {
      height: 500px;
      background-position: 50% 50% !important;
      .card_info {
        h3 {
          @apply mb-5;
        }
        p {
          @apply text-lg leading-normal;
        }
      }
    }
  }
}
.card_large {
  @apply shadow-lg bg-white p-7 border;
  p {
    width: 75%;
  }
  .card_play {
    padding-left: 40px;
    @apply font-normal text-left pl-16 leading-tight pr-4 py-4 border-t border-b;
    width: 50%;
    margin: 20px auto 0;
  }
  .regen {
    background: url("data:image/svg+xml,%3Csvg width='68' height='96' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M59.7.5c4.2 0 7.6 3.4 7.6 7.7v79.7c0 4.3-3.5 7.7-7.7 7.7H8.3a7.7 7.7 0 0 1-7.7-7.7V8.2C.6 3.9 4.1.5 8.3.5Zm-26.1 31a16 16 0 1 0 0 32 16 16 0 0 0 0-32Zm.03 3.15c.33-.28.84-.03.84.4v2.88c5.1.38 9.24 4.54 9.54 9.64a10.34 10.34 0 0 1-20.63 1.32.62.62 0 0 1 .63-.69h2.35c.33 0 .6.26.63.59a6.74 6.74 0 0 0 13.38.17 6.73 6.73 0 0 0-5.9-7.42v2.78c0 .43-.5.68-.84.4l-5.85-4.62a.53.53 0 0 1 0-.8Z' fill='green' fill-rule='nonzero'/%3E%3C/svg%3E")
      no-repeat 24px center #fafafa;
    background-size: 25px;
  }
  .single_use {
    background: url("data:image/svg+xml,%3Csvg width='68' height='96' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M59.7.5c4.2 0 7.6 3.4 7.6 7.7v79.7c0 4.3-3.5 7.7-7.7 7.7H8.3a7.7 7.7 0 0 1-7.7-7.7V8.2C.6 3.9 4.1.5 8.3.5Zm-26.1 31a16 16 0 1 0 0 32 16 16 0 0 0 0-32Zm.1 8.5 1 .1c.1.1.3.3.3.5l.1 1V47l.1 6.4h2.7v.1l.2.7c0 .3-.1.4-.2.5l-.6.2H29v-.2l-.2-.7c0-.2 0-.4.2-.5l.5-.1h2l.1-.1V45.1a24.3 24.3 0 0 0-.2-2.3c0-.2-.2-.3-.4-.4h-2v-.2l-.2-.6c0-.5.7-1 2-1.2 1.3-.3 2.2-.4 2.8-.4Z' fill='orangered' fill-rule='nonzero'/%3E%3C/svg%3E")
      no-repeat 24px center #fafafa;
    background-size: 25px;
  }
  .quote {
    width: 75%;
    @apply mx-auto text-xl pb-6 border-b mt-8;
    font-family: "EB Garamond", serif;
    font-weight: light;
  }
  .gameplay {
    @apply text-xl pt-5 mx-auto;
    font-family: "EB Garamond", serif;
    font-weight: light;
  }
  .card_header {
    width: 100%;
    height: auto;
    @apply flex items-end  bg-cover rounded;
    background-position: 10% 100% !important;
    background-color: #fafafa !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    p {
      font-family: "EB Garamond", serif;
    }
    .card_info {
      width: 80%;
      height: 100%;
      @apply py-8 pl-10 pr-0 mx-auto text-center;
      text-decoration: none;
      color: black;
      font-family: "EB Garamond", serif;
      backdrop-filter: blur(10px);

      h3 {
        @apply text-3xl mb-2 border-b pb-3;
        text-decoration: none;
      }
      p {
        @apply pr-0 w-full text-xl;
      }
    }
    &.has_image {
      .card_info {
        @apply text-left;
        width: 40%;
        margin: inherit;
        color: white;
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 1) 0%,
          rgba(0, 0, 0, 0) 100%
        );
        h3 {
          @apply mr-10;
        }
        p {
          @apply pr-8 text-base;
        }
      }
    }
  }
}
.sidebar {
  @apply bg-gray-100 pt-4;
}
h1.title {
  font-family: "EB Garamond", serif;
  text-shadow: 0px -1px 0px white;
  width: 80%;
  @apply text-5xl mt-4 mb-4 mx-auto pb-4 border-gray-200;
}
.link {
  &:hover {
    cursor: pointer;
  }
}

/* DivTable.com */
.divTable {
  display: table;
  width: 100%;
  @apply mx-auto;
}
.divTableRow {
  display: table-row;
}
.divTableRow:hover {
  cursor: pointer;
  background: #efefef;
}
.divTableHeading {
  background-color: #fff;
  display: table-header-group;
}
.divTableCell,
.divTableHead {
  border: 0.5px solid #ddd;
  display: table-cell;
  padding: 15px 20px;
  text-align: left;
}
.divTableHeading {
  background-color: #eee;
  display: table-header-group;
  font-weight: bold;
}
.divTableFoot {
  background-color: #eee;
  display: table-footer-group;
  font-weight: bold;
}
.divTableBody {
  display: table-row-group;
}
</style>
